import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { ANNUAL_REPORT_API } from "./apiRoutes";

const mutateDeleteAnnualReporting = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${ANNUAL_REPORT_API}/${id}`);
};

const useDeleteAnnualReportingMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteAnnualReporting,
    ...queryParams,
  });

export default useDeleteAnnualReportingMutation;
